/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cp_Form_InstitutionInputs */

const en_cp_form_institution = /** @type {(inputs: Cp_Form_InstitutionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Institution / campus / community`)
};

const id_cp_form_institution = /** @type {(inputs: Cp_Form_InstitutionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Institusi / kampus / komunitas`)
};

/**
* | output |
* | --- |
* | "Institution / campus / community" |
*
* @param {Cp_Form_InstitutionInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const cp_form_institution = /** @type {((inputs?: Cp_Form_InstitutionInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cp_Form_InstitutionInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_cp_form_institution(inputs)
	return en_cp_form_institution(inputs)
});